import {
  AvatarsCell,
  BadgesCell,
  ColorTypographyCell,
  DateChipCell,
  MailMenuCell,
  RowCell,
  TabIndexTable,
  WARNING_DAYS,
  formatPercent,
  formattedDate,
  numToPercent,
} from '@centerpiece/components';
import { Grid, Paper, Typography } from '@mui/material';
import { useAnalyticContext } from 'contexts/analytic.context';
import { useIndexContext } from 'contexts/index.context';
import moment from 'moment';
import { useMemo, useState, useCallback } from 'react';
import {
  useGetProjectTypesQuery,
  useGetRolesQuery,
  useGetPerformanceAnalyticsQuery,
  usePatchContactMutation,
} from 'store/api';
import { Contact, ProjectType } from 'store/api/models';
import { numFormatter } from 'utils/index.utils';

export const FinancialPerformanceTable = () => {
  const {
    contactRecord,
    team,
    setTeam,
    individual,
    setIndividual,
    projectType,
    setProjectType,
  } = useAnalyticContext();
  const { data: performances = {} } = useGetPerformanceAnalyticsQuery({
    params: {
      team: team?.id,
      individual: individual?.id,
      project_type: projectType.id,
    },
  });
  const [patchContact, patchContactResult] = usePatchContactMutation();
  const { data: roles = [] } = useGetRolesQuery({});
  const [typeFilter, setTypeFilter] = useState<ProjectType>();
  const tableprops: any = useMemo(
    () => ({
      // filters: [
      //   {
      //     options: project_types,
      //     label: 'Project Types',
      //     defaultOption: typeFilter,
      //     onChange: (event: any, newValue: any) => setTypeFilter(newValue),
      //     // loading: projectListFetching,
      //   },
      // ],
      // onRowClick: (event: any, row: any) => navigate(`project/${row.id}`),
      // isLoading: projectListLoading,
      defaultOrder: 'desc',
      defaultOrderBy: 'rev.sort',
      // hoverCell: true,
      headCells: [
        // {
        //   name: 'icon',
        //   icon: true,
        //   label: 'Class',
        // },
        {
          name: 'name',
          label: 'Name',
          textFilter: 'name.text',
          sort: 'name.text',
          component: ColorTypographyCell,
        },
        {
          name: 'num',
          label: '# of Projects',
          sort: 'num.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'rev',
          label: '$ Amount',
          sort: 'rev.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'avg_uplift',
          label: 'Avg Sales Uplift',
          sort: 'avg_uplift.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'avg_margin_uplift',
          label: 'Avg Margin Uplift',
          sort: 'avg_margin_uplift.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'max_uplift',
          label: 'Max Uplift',
          sort: 'max_uplift.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'min_uplift',
          label: 'Min Uplift',
          sort: 'min_uplift.sort',
          component: ColorTypographyCell,
        },
      ],
    }),
    []
  );
  return (
    <Paper elevation={5} sx={{ p: 2 }}>
      {/* <Grid
        container
        alignItems="left"
        sx={{
          pl: { xs: 2, md: 4 },
          pr: { xs: 2, md: 4 },
          pt: 2,
          pb: 1,
        }}
      > */}
      <Typography variant="h6" sx={{ my: 1 }}>
        Financial Performance
      </Typography>
      {/* {exportResult.isLoading ? (
              <CircularProgress size={16} />
            ) : (
              <IconButton
                onClick={() => {
                  exportData({
                    params: {
                      team: team?.id,
                      individual: individual?.id,
                    },
                  });
                }}
                sx={{ ml: 2 }}
                size="large"
              >
                <CloudDownload />
              </IconButton>
            )} */}
      {/* </Grid> */}
      <TabIndexTable
        config={useMemo(
          () => contactRecord?.form?.uplift || ({ tabs: null } as any),
          [contactRecord?.form?.uplift]
        )}
        onConfigChange={useCallback(
          async (config: any) => {
            await patchContact({
              id: contactRecord.id,
              form: { uplift: { ...config } },
            } as Contact);
          },
          [contactRecord.id]
        )}
        configLoading={patchContactResult.isLoading}
        initialTab={0}
        tables={useMemo(
          () => [
            {
              title: 'Individuals',
              key: `individuals`,
              visible: true,
              ...tableprops,
              rows:
                performances?.individual?.map((v: any) => ({
                  name: {
                    text: `${v.contact_r.firstname} ${v.contact_r.lastname}`,
                  },
                  num: { text: v.num_projects, sort: v.num_projects },
                  rev: {
                    text: v.revenue_sum
                      ? `$${numFormatter(v.revenue_sum)}`
                      : undefined,
                    sort: v.revenue_sum,
                  },
                  avg_uplift: {
                    text: v.avg_uplift
                      ? `$${numFormatter(v.avg_uplift)}`
                      : undefined,
                    sort: v.avg_uplift,
                  },
                  avg_margin_uplift: {
                    text: v.avg_margin_uplift
                      ? `${formatPercent(v.avg_margin_uplift)}`
                      : undefined,
                    sort: v.avg_margin_uplift,
                  },
                  max_uplift: {
                    text: v.max_uplift
                      ? `$${numFormatter(v.max_uplift)}`
                      : undefined,
                    sort: v.max_uplift,
                  },
                  min_uplift: {
                    text: v.min_uplift
                      ? `$${numFormatter(v.min_uplift)}`
                      : undefined,
                    sort: v.min_uplift,
                  },
                })) || ([] as RowCell[]),
            },
            {
              title: 'Stakeholders',
              key: `stakeholders`,
              visible: true,
              ...tableprops,
              rows:
                performances?.stakeholder?.map((v: any) => ({
                  name: {
                    text: `${v.contact_r.firstname} ${v.contact_r.lastname}`,
                  },
                  num: { text: v.num_projects, sort: v.num_projects },
                  rev: {
                    text: v.revenue_sum
                      ? `$${numFormatter(v.revenue_sum)}`
                      : undefined,
                    sort: v.revenue_sum,
                  },
                  avg_uplift: {
                    text: v.avg_uplift
                      ? `$${numFormatter(v.avg_uplift)}`
                      : undefined,
                    sort: v.avg_uplift,
                  },
                  avg_margin_uplift: {
                    text: v.avg_margin_uplift
                      ? `${formatPercent(v.avg_margin_uplift)}`
                      : undefined,
                    sort: v.avg_margin_uplift,
                  },
                  max_uplift: {
                    text: v.max_uplift
                      ? `$${numFormatter(v.max_uplift)}`
                      : undefined,
                    sort: v.max_uplift,
                  },
                  min_uplift: {
                    text: v.min_uplift
                      ? `$${numFormatter(v.min_uplift)}`
                      : undefined,
                    sort: v.min_uplift,
                  },
                })) || ([] as RowCell[]),
            },
            {
              title: 'Organizations',
              key: `organizations`,
              visible: true,
              ...tableprops,
              rows:
                performances?.organization?.map((v: any) => ({
                  name: { text: v.organization_r.name },
                  num: { text: v.num_projects, sort: v.num_projects },
                  rev: {
                    text: v.revenue_sum
                      ? `$${numFormatter(v.revenue_sum)}`
                      : undefined,
                    sort: v.revenue_sum,
                  },
                  avg_uplift: {
                    text: v.avg_uplift
                      ? `$${numFormatter(v.avg_uplift)}`
                      : undefined,
                    sort: v.avg_uplift,
                  },
                  avg_margin_uplift: {
                    text: v.avg_margin_uplift
                      ? `${formatPercent(v.avg_margin_uplift)}`
                      : undefined,
                    sort: v.avg_margin_uplift,
                  },
                  max_uplift: {
                    text: v.max_uplift
                      ? `$${numFormatter(v.max_uplift)}`
                      : undefined,
                    sort: v.max_uplift,
                  },
                  min_uplift: {
                    text: v.min_uplift
                      ? `$${numFormatter(v.min_uplift)}`
                      : undefined,
                    sort: v.min_uplift,
                  },
                })) || ([] as RowCell[]),
            },
            {
              title: 'Projects',
              key: `projects`,
              visible: true,
              ...tableprops,
              headCells: [
                // {
                //   name: 'icon',
                //   icon: true,
                //   label: 'Class',
                // },
                {
                  name: 'name',
                  label: 'Name',
                  textFilter: 'name.text',
                  sort: 'name.text',
                  component: ColorTypographyCell,
                },
                {
                  name: 'rev',
                  label: '$ Amount',
                  sort: 'rev.sort',
                  component: ColorTypographyCell,
                },
                {
                  name: 'uplift',
                  label: '$ Sales Uplift',
                  sort: 'uplift.sort',
                  component: ColorTypographyCell,
                },
                {
                  name: 'uplift_percent',
                  label: '% Sales Uplift',
                  sort: 'uplift_percent.sort',
                  component: ColorTypographyCell,
                },
                {
                  name: 'margin',
                  label: 'Realized Margin',
                  sort: 'margin.sort',
                  component: ColorTypographyCell,
                },
                {
                  name: 'margin_uplift',
                  label: '% Margin Uplift',
                  sort: 'margin_uplift.sort',
                  component: ColorTypographyCell,
                },
                // {
                //   name: 'gross_profit_uplift',
                //   label: 'Gross Profit Uplift',
                //   sort: 'gross_profit_uplift.sort',
                //   component: ColorTypographyCell,
                // },
              ],
              rows:
                performances?.project?.map((v: any) => ({
                  name: { text: v.project_r.title },
                  num: { text: v.num_projects, sort: v.num_projects },
                  rev: {
                    text:
                      v.realized_revenue || v.revenue
                        ? `$${numFormatter(v.realized_revenue || v.revenue)}`
                        : undefined,
                    sort: v.realized_revenue || v.revenue,
                  },
                  uplift: {
                    text:
                      v.realized_revenue && v.revenue
                        ? `$${numFormatter(v.realized_revenue - v.revenue)}`
                        : undefined,
                    sort:
                      v.realized_revenue && v.revenue
                        ? v.realized_revenue - v.revenue
                        : undefined,
                  },
                  uplift_percent: {
                    text:
                      v.realized_revenue && v.revenue
                        ? `${numToPercent(
                            (v.realized_revenue - v.revenue) / v.revenue
                          )}`
                        : undefined,
                    sort:
                      v.realized_revenue && v.revenue
                        ? (v.realized_revenue - v.revenue) / v.revenue
                        : undefined,
                  },
                  margin: {
                    text:
                      v.realized_margin || v.margin
                        ? `${formatPercent(v.realized_margin || v.margin)}`
                        : undefined,
                    sort: v.realized_margin || v.margin,
                  },
                  margin_uplift: {
                    text:
                      v.realized_margin &&
                      v.margin &&
                      Number(v.realized_margin) > 0 &&
                      Number(v.margin) > 0
                        ? `${formatPercent(v.realized_margin - v.margin)}`
                        : undefined,
                    sort:
                      v.realized_margin &&
                      v.margin &&
                      Number(v.realized_margin) > 0 &&
                      Number(v.margin) > 0
                        ? v.realized_margin - v.margin
                        : undefined,
                  },
                  // gross_profit_uplift: {
                  //   text:
                  //     v.realized_margin &&
                  //     v.margin &&
                  //     v.realized_revenue &&
                  //     v.revenue &&
                  //     Number(v.realized_margin) > 0 &&
                  //     Number(v.margin) > 0 &&
                  //     Number(v.realized_revenue) > 0 &&
                  //     Number(v.revenue) > 0
                  //       ? `$${numFormatter(
                  //           (v.realized_revenue - v.revenue) *
                  //             (v.realized_margin - v.margin)
                  //         )}`
                  //       : undefined,
                  //   sort:
                  //     v.realized_margin &&
                  //     v.margin &&
                  //     v.realized_revenue &&
                  //     v.revenue &&
                  //     Number(v.realized_margin) > 0 &&
                  //     Number(v.margin) > 0 &&
                  //     Number(v.realized_revenue) > 0 &&
                  //     Number(v.revenue) > 0
                  //       ? (v.realized_revenue - v.revenue) *
                  //         (v.realized_margin - v.margin)
                  //       : undefined,
                  // },
                })) || ([] as RowCell[]),
            },
          ],
          [tableprops, performances]
        )}
      />
    </Paper>
  );
};
